import { render, staticRenderFns } from "./IslamicFinanceAttachmentModal.vue?vue&type=template&id=3f0fd31b"
import script from "./IslamicFinanceAttachmentModal.vue?vue&type=script&lang=js"
export * from "./IslamicFinanceAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0fd31b')) {
      api.createRecord('3f0fd31b', component.options)
    } else {
      api.reload('3f0fd31b', component.options)
    }
    module.hot.accept("./IslamicFinanceAttachmentModal.vue?vue&type=template&id=3f0fd31b", function () {
      api.rerender('3f0fd31b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/islamicFinanceModal/IslamicFinanceAttachmentModal.vue"
export default component.exports